import axios, { AxiosResponse } from 'axios';
import { LoginReq, LoginRes } from '@models/User';
import { loadConfig } from '@api/api';

const getAuthApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/auth`;
};

const getAdminAuthApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/user`;
};

export const signIn = async ({ userName, password }: LoginReq) => {
  const AUTH_API = await getAuthApi();
  const res: AxiosResponse<LoginRes> = await axios(`${AUTH_API}/login`, {
    method: 'post',
    data: {
      name: userName,
      password: password,
    },
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
  return res;
};

export const signOut = async ({ accessToken }: { accessToken: string }) => {
  const AUTH_API = await getAuthApi();
  const response: AxiosResponse<LoginRes> = await axios(`${AUTH_API}/logout`, {
    method: 'post',
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
  return response;
};

export const refreshAuth = async ({
  refreshToken,
}: {
  refreshToken: string;
}) => {
  const AUTH_API = await getAuthApi();
  const response: AxiosResponse<LoginRes> = await axios(`${AUTH_API}/refresh`, {
    method: 'post',
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${refreshToken}`,
    },
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const patchPassword = async ({
  accessToken,
  body,
  isAdmin = false,
}: {
  accessToken: string;
  body: {
    user_name: string;
    password: string;
    oldPassword: string;
  };
  isAdmin?: boolean;
}) => {
  const AUTH_API = await getAuthApi();
  const ADMIN_API = await getAdminAuthApi();
  const passwordApi = isAdmin
    ? `${ADMIN_API}/${body.user_name}`
    : `${AUTH_API}/me`;

  const response: AxiosResponse<LoginRes> = await axios(passwordApi, {
    method: 'patch',
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
    data: {
      ...body,
    },
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
  return response;
};
